;(function(w){
	function LightboxContenidoFlipcard(element){
		
		var active = false;

		var titulo = $(element).find('.flipcard-header h4').text();

		$(element).find('a').bind('click', onClickThis);

		function onClickThis(e){
			e.preventDefault();
			
			if(active){
				active = false;
				$(element).removeClass('active');
			}else{
				active = true;
				$(element).addClass('active');

				ga('send', {hitType: 'event', eventCategory: 'Flipcards',  eventAction: 'Click', eventLabel: titulo});
			}
		}
	}
	
	w.LightboxContenidoFlipcard = LightboxContenidoFlipcard;
})(window)